import { render, staticRenderFns } from "./TeamManagment.vue?vue&type=template&id=06d980d7&scoped=true"
import script from "./TeamManagment.vue?vue&type=script&lang=js"
export * from "./TeamManagment.vue?vue&type=script&lang=js"
import style0 from "./TeamManagment.vue?vue&type=style&index=0&id=06d980d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d980d7",
  null
  
)

export default component.exports